<template>
  <div class="receiptBaseInfo">
    <base-form
      v-model="baseData"
      :options="baseDataOptions"
      ref="basicInfo"
      :disabled="!canEdit"
      @input="handleChangeBaseData"
      label-width="105px"
    ></base-form>
  </div>
</template>
<script>
  import baseForm from '@/components/form/base-form';
  import { mapState } from 'vuex';
  import { dateFormatter } from '@/common/js/util';
  import DataBaseAPI from '@/api/dataBase';

  export default {
    name: 'basicInfo',
    components: {
      baseForm,
    },
    props: ['canEdit'],
    data() {
      return {
        baseData: {
          id: null,
          businessCompanyCode: null,
          businessCompanyName: null,
          docNo: null,
          operaterNo: null,
          operaterName: null,
          operaterDate: null,
          docStatus: null,
          effectiveDate: null,
          customer: null,
          customerNo: null,
          customerName: null,
          remark: null,
        },
        companyList: [],
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      //基础数据表单配置
      baseDataOptions() {
        return [
          {
            // 公司
            prop: 'businessCompanyCode',
            label: this.$t('customerBalanceAdjust.column.businessCompanyName'),
            type: 'select',
            options: this.companyList,
            required: true,
            filterable: true,
          },
          {
            // 单据编号
            prop: 'docNo',
            label: this.$t('customerBalanceAdjust.column.docNo'),
            type: 'input',
            disabled: true,
            placeholder: this.$t('customerBalanceAdjust.placeholder.auto'),
          },
          {
            // 制单人
            prop: 'operaterName',
            label: this.$t('customerBalanceAdjust.column.operaterName'),
            type: 'input',
            disabled: true,
          },
          {
            // 制单日期
            prop: 'operaterDate',
            label: this.$t('customerBalanceAdjust.column.operaterDate'),
            type: 'date',
            disabled: true,
          },
          {
            // 单据状态
            prop: 'docStatus',
            label: this.$t('customerBalanceAdjust.column.docStatus'),
            type: 'dict',
            dictType: 'customer_balance_status',
            disabled: true,
            placeholder: this.$t('customerBalanceAdjust.placeholder.auto'),
          },
          {
            // 生效日期
            prop: 'effectiveDate',
            label: this.$t('customerBalanceAdjust.column.effectiveDate'),
            type: 'date',
            disabled: true,
          },
          //客户名称
          {
            prop: 'customer',
            type: 'searchTable',
            label: this.$t('customerBalanceAdjust.column.partnerName'),
            searchType: 'customer',
            isMultiple: true,
            required: true,
            propCode: 'partnerCode',
            propName: 'partnerZhName',
            currentValue: this.baseData.customerName,
          },
          {
            // 备注
            prop: 'remark',
            label: this.$t('customerBalanceAdjust.column.remark'),
            type: 'input',
            clearable: true,
            required: false,
            span: 20,
          },
        ];
      },
    },
    mounted() {
      this.getCompany();
      if (this.$route.name.indexOf('Add') != -1) {
        this.baseData.businessCompanyCode = this.userInfo.companyCode;
        this.baseData.businessCompanyName = this.userInfo.companyName;
        this.baseData.operaterName = this.userInfo.userName;
        this.baseData.operaterNo = this.userInfo.userCode;
        this.baseData.operaterDate = dateFormatter(new Date());
      }
    },
    methods: {
      handleChangeBaseData(value, prop) {
        //基本数据表单变化
        if (prop == 'businessCompanyName') {
          this.companyChange(value.businessCompanyCode);
        }
        //客户-默认为付款单位
        if (prop == 'customer') {
          const customer = value.customer;
          //客户
          // this.params.customer = obj.val ? obj.val[0].partnerZhName : null;
          this.baseData.customerNo = customer ? customer[0].partnerCode : null;
          this.baseData.customerName = customer ? customer[0].partnerZhName : null;
          //客户类别
          this.baseData.customerType = customer ? customer[0].partnerForm : null;
          this.baseData.customer = [
            {
              customerNo: this.baseData.customerNo,
              customerName: this.baseData.customerName,
              customerType: this.baseData.customerType,
            },
          ];
        }
      },
      async getCompany() {
        // 公司
        let params = {
          id: this.userInfo.userCode,
          userCode: this.userInfo.userCode,
          personName: this.userInfo.userName,
        };
        const selectStatus = await this.$axios.post(DataBaseAPI.GET_PERSON_API, params);
        if (selectStatus.data.code == 0) {
          this.companyList = selectStatus.data.data.personCompanyInfo.map((item) => {
            return {
              value: item.personCompanyCode,
              label: item.personCompanyName,
            };
          });
        }
      },
      companyChange(val) {
        this.baseData.businessCompanyName = val
          ? this.companyList.find((item) => item.value == val).label
          : null;
      },
      exportChildData() {
        // 返回数据
        let sign = false;
        this.$refs.basicInfo.$refs.ruleForm.validate((valid) => {
          if (valid) {
            sign = true;
          } else {
            sign = false;
          }
        });
        return sign ? this.baseData : false;
      },
    },
  };
</script>
